import React, { useState, useEffect } from 'react';
import { View, Text, Image } from 'react-native';
import { Checkbox } from 'react-native-paper';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';

import styles from './styles';

const ConfirmPurchase = (props) => {
    const [checked, setChecked] = useState(false);
    const [uri, setUri] = useState('');
    const [qtd, setQtd] = useState(1);
    const [nameToken, setNameToken] = useState('GPX');
    const [valueToken, setValueToken] = useState(1);


    useEffect(() => {
        getDataCoin();

        props.route.params.qtd ? setQtd(props.route.params.qtd) : setQtd(1)
    }, []);

    const getDataCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        const idCoin = await AsyncStorage.getItem('id_coin');

        api.get(`/actives/${idCoin}`, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                // console.log(res.data)
                setNameToken(res.data.actives[0].name_token)
                setUri(`https://filesgpx.s3.us-east-2.amazonaws.com/${res.data.actives[0].path}`)

                res.data.actives[0].type_value == "Valor Fixo" ?
                    setValueToken(res.data.actives[0].single_value)
                    : setValueToken(res.data.actives[0].total_value_token)

            })
            .catch((error) => {
                console.log(error);
            })
    }

    return (
        <>
            <HeaderDefault title={"Confirmar compra"} />

            <View style={styles.container}>
                <Text style={styles.title}>Você confirma a compra abaixo?</Text>

                <View style={styles.contentImgsCoins}>
                    {uri == '' ?
                        <Image source={require('../../../assets/imgs/gpx.png')} style={styles.imgCoins} />
                        :
                        <Image source={{ uri: uri }} style={styles.imgCoins} />
                    }
                    <Image source={require('../../../assets/imgs/gpx.png')} style={styles.imgCoins} />
                </View>

                <View style={styles.contentPrice}>
                    <View>
                        <Text style={styles.textPriceLeft}>Compra</Text>
                        <Text style={styles.price}>{qtd} {nameToken}</Text>
                    </View>
                    <View>
                        <Text style={styles.textPriceRight}>Valor</Text>
                        <Text style={styles.price}>{qtd * valueToken}GPX</Text>
                    </View>
                </View>

                <View style={styles.hr} />

                <View style={styles.contentCheckbox}>
                    <Checkbox
                        status={checked ? 'checked' : 'indeterminate'}
                        onPress={() => {
                            setChecked(!checked);
                        }}
                    />
                    <Text>
                        Ao clicar aqui eu concordo com os
                        <Text style={{ textDecorationLine: 'underline' }}> Termos de Uso</Text>,
                        <Text style={{ textDecorationLine: 'underline' }}> Política de Privacidade</Text>,
                        <Text style={{ textDecorationLine: 'underline' }}> Condições de Pagamento</Text>.
                    </Text>
                </View>
            </View>

            <Button route={"PaymentMethod"} text={"CONFIRMAR"} props={qtd} />
        </>
    );
}

export default ConfirmPurchase;